// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2MNod","inner":"Footer_inner__1eNuJ"};